/**
 * @file コンポーネント：症例サムネイル動画 ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const OperationThumbnailVideo = (props) => {
    // 自動再生、ループ再生
    const [mediaPlayerThumbnail, setMediaPlayerThumbnail] = useState(null);
    useEffect(() => {
        if (mediaPlayerThumbnail === null) return;
        // 自動再生
        mediaPlayerThumbnail.setAttribute("playsinline", "");
        mediaPlayerThumbnail.muted = true;
        mediaPlayerThumbnail.play();
        // ループ再生
        mediaPlayerThumbnail.addEventListener("ended", () => {
            mediaPlayerThumbnail.play();
        });
    }, [mediaPlayerThumbnail]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            setMediaPlayerThumbnail={setMediaPlayerThumbnail}
        />
    );
};
